import { ValidationRuleTriggers } from "./triggers";
import { InputValidationResult, InputValidationResultKind } from "../input";
import { localize } from "client_legacy/ndaw/culture";

class IsTrueRule extends ValidationRuleTriggers<boolean> {
	private readonly _alternativeMessage: string | undefined;

	constructor(alternativeMessage?: string) {
		super();
		this._alternativeMessage = alternativeMessage;
	}

	public validate(value: boolean): InputValidationResult {
		if (value) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		return {
			kind: InputValidationResultKind.Invalid,
			errorMessage: this._alternativeMessage || localize("_MustBeChecked")
		};
	}
}

export {
	IsTrueRule
};